import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Col,
  Row,
  Tabs,
  Tab,
  ButtonToolbar,
  Modal,
} from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  CardHeaderTitle,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { UserTable } from "./UserTable";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import {
  fetchId,
  selectLoading,
  fetchRole,
  selectRole,
  selectDataId,
  editItem,
  addOfficeUser,
  selectDataIdUser,
  fetchIdUser,
  editEmployee,
  removeUserOffice,
  unlockUserUpdate,
  resetUserUpdate,
  selectRoleModal,
  fetchRoleModal,
  editOfficeUser,
  releaseUser,
  setPermissionBasicInfo,
  setPermissionAccount,
  setPermissionOfficeMapping,
  selectPermissionBasicInfo,
  selectPermissionAccount,
  selectPermissionOfficeMapping,
} from "./userSlice";
import {
  checkPermision,
  formLabelsTheme,
  iconError,
  showConfirmDialog,
  showDeleteDialog,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
  validatePost,
} from "../../utility";
import BootstrapTable from "react-bootstrap-table-next";
import Select from "react-select";
import { addItem } from "./userSlice";
import { fetchOffice, selectOffice } from "../office/officeSlice";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";

import { makeStyles, fade, ThemeProvider } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import {
  fetchParameter,
  fetchParameter2,
  selectParameter,
  selectParameter2,
} from "../businessParameter/businessParameterSlice";
import {
  FormControlLabel,
  FormHelperText,
  MenuItem,
  Radio,
  RadioGroup,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { fetchCountryAll, selectCountryAll } from "../location/locationSlice";
import { fetchMenuTab, selectMenuTab } from "../menu/menuSlice";

const useStylesReddit = makeStyles((theme) => ({
  root: {
    border: "1px solid #e2e2e1",
    overflow: "hidden",
    borderRadius: 4,
    backgroundColor: "#FFFFFF",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    "&:hover": {
      backgroundColor: "#fff",
    },
    "&$focused": {
      backgroundColor: "#fff",
      boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
      borderColor: theme.palette.primary.main,
    },
  },
  focused: {},
}));
function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  margin: {
    margin: theme.spacing(1),
  },
}));

export const UserEdit = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const dataId = useSelector(selectDataId);
  const dataOffice = useSelector(selectOffice);
  const dataUser = useSelector(selectDataIdUser);
  const { id } = useParams();
  const icon = <SVG src={toAbsoluteUrl("/media/svg/icons/New/x-error.svg")} />;
  const dataMenuTab = useSelector(selectMenuTab);
  const permissionBasicInfo = useSelector(selectPermissionBasicInfo);
  const permissionAccount = useSelector(selectPermissionAccount);
  const permissionOfficeMapping = useSelector(selectPermissionOfficeMapping);

  const dataRole = useSelector(selectRoleModal);
  const dataParam = useSelector(selectParameter); //Country
  const dataParam2 = useSelector(selectParameter2); //Phone type
  const dataCountry = useSelector(selectCountryAll);

  const [username, setUsername] = useState("");
  const [role, setRole] = useState("");
  const [selected, setSelected] = useState(null);
  const [office, setOffice] = useState("");
  const [officeName, setOfficeName] = useState("");
  const [userOfficeID, setUserOfficeID] = useState("");
  const [tableDataUserOffice, setTableDataUserOffice] = useState([]);

  const [emp_id, setEmp_id] = useState("");
  const [first_name, setFirst_name] = useState("");
  const [last_name, setLast_name] = useState("");
  const [designation, setDesignation] = useState("");
  const [address1, setAddress1] = useState("");
  const [address2, setAddress2] = useState("");
  const [city, setCity] = useState("");
  const [zipcode, setZipcode] = useState("");
  const [country_id, setCountry_id] = useState("");
  const [province, setProvince] = useState("");
  const [cp_first_name, setCp_first_name] = useState("");
  const [cp_last_name, setCp_last_name] = useState("");
  const [cp_email, setCp_email] = useState("");
  const [contactpersons, setContactpersons] = useState([]);
  const [list, setList] = useState(null);

  const [formUser, setFormUser] = useState({
    username: {
      value: "",
      error: false,
      required: "Y",
    },
  });

  useEffect(() => {
    async function fetchMyAPI() {
      await dispatch(
        fetchMenuTab({
          menu_url: "/administration/management-user/profile",
        })
      );
      await callApi(id);
      await dispatch(
        fetchCountryAll({
          is_enable: "Y",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchParameter2({
          paramgroup_code: "PHONETYPE",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchRoleModal({
          is_enable: "Y",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchOffice({
          pageNo: 1,
          pageSize: -1,
        })
      );
    }
    fetchMyAPI();
  }, [dispatch, id]);

  useEffect(() => {
    if (dataMenuTab.length > 0) {
      const data = dataMenuTab.map((item) => item.menu_name);
      setList(data);
      setActive(data[0]);
      // dispatch(setDefaultTab(data[0]));
      const master = dataMenuTab.map((item, index) => {
        if (item.menu_name === "Basic Information") {
          return dispatch(setPermissionBasicInfo(item.permissions));
        }
        if (item.menu_name === "Account Setting") {
          return dispatch(setPermissionAccount(item.permissions));
        }
        if (item.menu_name === "Office Mapping") {
          return dispatch(setPermissionOfficeMapping(item.permissions));
        }
      });
    }
  }, [dataMenuTab]);

  useEffect(() => {
    if (dataId !== null) {
      setEmp_id(dataId.emp_id);
      setFirst_name(dataId.first_name);
      setLast_name(dataId.last_name);
      setDesignation(dataId.designation);
      setAddress1(dataId.address1);
      setAddress2(dataId.address2);
      setCity(dataId.city);
      setZipcode(dataId.zipcode);
      setCountry_id(dataId.country_id);
      setProvince(dataId.province);
      setCp_first_name(dataId.cp_first_name);
      setCp_last_name(dataId.cp_last_name);
      setCp_email(dataId.cp_email);
      setUsername(dataId.username);

      const initData =
        dataId.contactpersons === null
          ? [
              {
                cp_id: "",
                emp_id: dataId.emp_id,
                phone_type: "",
                phone: "",
              },
            ]
          : dataId.contactpersons.map((item, index) => {
              return {
                cp_id: item.cp_id,
                emp_id: item.emp_id,
                phone_type: item.phone_type,
                phone: item.phone,
              };
            });

      setFields(initData);

      setFormValues({
        emp_id: {
          value: dataId.emp_id,
          error: false,
          errorMessage: "This field is required",
          required: "Y",
        },
        first_name: {
          value: dataId.first_name,
          error: false,
          errorMessage: "This field is required",
          required: "Y",
        },
        address1: {
          value: dataId.address1,
          error: false,
          errorMessage: "This field is required",
          required: "Y",
        },
      });

      if (dataId.username !== null) {
        callApiUser(dataId.username);
      }
    }
  }, [dataId]);

  useEffect(() => {
    if (dataUser !== null) {
      const initData = dataUser.userOffices.map((item, index) => {
        return {
          ...item,
          no: index + 1,
          role_name:
            item.roles === null
              ? ""
              : item.roles.map((item) => item.role_description).join(","),
        };
      });

      setTableDataUserOffice(initData);
    }
  }, [dataUser]);

  const [formValues, setFormValues] = useState({
    emp_id: {
      value: "",
      error: false,
      errorMessage: "This field is required",
    },
    first_name: {
      value: "",
      error: false,
      errorMessage: "This field is required",
    },
    address1: {
      value: "",
      error: false,
      errorMessage: "This field is required",
    },
  });

  const handleChangeUser = (e) => {
    const { name, value } = e.target;
    setFormUser({
      ...formUser,
      [name]: {
        ...formUser[name],
        value,
      },
    });
  };

  const handleSaveBasicInfo = async () => {
    if (!validatePost(formValues, setFormValues)) {
      return;
    }

    const params = {
      id: dataId.id,
      emp_id: emp_id,
      first_name: formValues.first_name.value,
      last_name: last_name,
      designation: designation,
      address1: formValues.address1.value,
      address2: address2,
      city: city,
      zipcode: zipcode,
      country_id: country_id,
      province: province,
      cp_first_name: cp_first_name,
      cp_last_name: cp_last_name,
      cp_email: cp_email,

      contactpersons: fields,
    };

    console.log(params, "params");

    try {
      const response = await dispatch(editEmployee(params));
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await window.location.reload();
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const callApi = async (id) => {
    try {
      const response = await dispatch(fetchId(id));
      if (response.payload.status === 200) {
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const callApiUser = async (id) => {
    try {
      const response = await dispatch(fetchIdUser(id));
      if (response.payload.status === 200) {
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const [active, setActive] = useState("");

  console.log(formValues, "formValues");

  // account setting
  const handleSaveUser = async () => {
    if (!validatePost(formUser, setFormUser)) {
      return;
    }

    const params = {
      emp_id: dataId.emp_id,
      username: formUser.username.value,
    };

    try {
      const response = await dispatch(addItem(params));
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await callApi(id);
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleReset = async () => {
    const params = [
      {
        username: dataId.username,
        is_reset: "Y",
      },
    ];
    const action = await showConfirmDialog(`Are you sure want to reset ?`);
    if (action.isConfirmed) {
      try {
        const response = await dispatch(resetUserUpdate(params));
        if (response.payload.status === 200) {
          const action = await showSuccessDialog(response.payload.message);
          await window.location.reload();
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleRelaseuser = async () => {
    const params = {
      username: dataId.username,
    };

    const action = await showConfirmDialog(`Are you sure want to reset ?`);
    if (action.isConfirmed) {
      try {
        const response = await dispatch(releaseUser(params));
        if (response.payload.status === 200) {
          const action = await showSuccessDialog(response.payload.message);
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleLock = async () => {
    const params = [
      {
        username: dataId.username,
        is_locked: "N",
      },
    ];
    console.log(params, "params");
    const action = await showConfirmDialog(`Are you sure want to unlock User?`);
    if (action.isConfirmed) {
      try {
        const response = await dispatch(unlockUserUpdate(params));
        console.log(unlockUserUpdate, "unlock");
        if (response.payload.status === 200) {
          const action = await showSuccessDialog(response.payload.message);
          await window.location.reload();
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
      }
    }
  };

  const handleDeleteOffice = async (row) => {
    const params = { office_id: `${row.office_id}`, user_id: `${row.user_id}` };
    const action = await showDeleteDialog(
      `Are you sure you want to delete?<br><strong>${row.office_code}</strong>`
    );
    if (action.isConfirmed) {
      try {
        const response = await dispatch(removeUserOffice({ data: params }));
        if (response.payload.data.status === 200) {
          const action = await showSuccessDialog(response.payload.data.message);
          await callApi(id);
          await handleClose();
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const actionFormatterOffice = (e, row, rowIndex) => {
    return (
      <>
        <div>
          {checkPermision(permissionOfficeMapping, "UPDATE") && (
            <OverlayTrigger
              overlay={<Tooltip id="products-edit-tooltip">Edit</Tooltip>}
            >
              <div
                className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                onClick={(e) => {
                  console.log(row, "row");
                  setUserOfficeID(row.useroffice_id);
                  setOffice(row.office_id);
                  setListRole(row.roles);
                  setSelectedValue(row.is_base);
                  handleShow();
                }}
              >
                <span className="svg-icon svg-icon-md svg-icon-light">
                  <SVG src={toAbsoluteUrl("/media/svg/icons/New/edit.svg")} />
                </span>
              </div>
            </OverlayTrigger>
          )}

          {checkPermision(permissionOfficeMapping, "DELETE") && (
            <OverlayTrigger
              overlay={<Tooltip id="products-delete-tooltip">Delete</Tooltip>}
            >
              <div
                className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mb-1"
                onClick={() => handleDeleteOffice(row)}
              >
                <span className="svg-icon svg-icon-md svg-icon-light">
                  <SVG src={toAbsoluteUrl("/media/svg/icons/New/delete.svg")} />
                </span>
              </div>
            </OverlayTrigger>
          )}
        </div>
      </>
    );
  };

  // New
  const columns = [
    {
      text: "No",
      dataField: "no",

      style: { minWidth: "60px" },
      headerAlign: "center",
      hidden: true,
    },
    {
      text: "Office Code",
      dataField: "office_code",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Office Name",
      dataField: "office_name",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Roles",
      dataField: "role_name",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      dataField: "actions",
      text: "Actions",
      formatter: actionFormatterOffice,
      align: "center",
      headerAlign: "center",
    },
  ];

  // Func Modal
  const [show, setShow] = useState(false);
  const [listRole, setListRole] = useState([]);

  const handleClose = () => {
    {
      setOffice("");
      setListRole([]);
      setSelectedValue("Y");
      setUserOfficeID("");
      setShow(false);
    }
  };
  const handleShow = () => setShow(true);

  const handleDelete = (e, row, rowIndex, formatExtraData) => {
    const idColumn = row.role_id;
    const temp = [...formatExtraData];

    let items = temp.filter((value, index) => value.role_id !== idColumn);

    setListRole(items);
  };

  const actionFormatter = (e, row, rowIndex, formatExtraData) => {
    return (
      <div>
        <span className="mx-2"></span>
        <OverlayTrigger
          overlay={<Tooltip id="products-delete-tooltip">Delete</Tooltip>}
        >
          <div
            className="btn btn-icon btn-primary btn-hover-primary btn-sm"
            onClick={(e) => handleDelete(e, row, rowIndex, formatExtraData)}
          >
            <span className="svg-icon svg-icon-md svg-icon-light">
              <SVG src={toAbsoluteUrl("/media/svg/icons/New/delete.svg")} />
            </span>
          </div>
        </OverlayTrigger>
      </div>
    );
  };

  const columnsOffice = [
    {
      text: "No",
      dataField: "no",
      headerAlign: "center",
      hidden: true,
    },

    {
      text: "Role",
      dataField: "role_description",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Actions",
      dataField: "actions",
      formatter: actionFormatter,
      style: { minWidth: "60px" },
      align: "center",
      headerAlign: "center",
      formatExtraData: listRole,
    },
  ];

  const officeOptions = dataOffice.map((e) => {
    return {
      value: e.office_id,
      label: e.office_name,
    };
  });

  const handleOfficeChange = (e) => {
    if (e === null) {
      e = undefined;
      setOffice("");
      setOfficeName("");
    } else {
      setOffice(e.value);
      setOfficeName(e.label);
    }
  };

  // fetch role
  const roleOptions = dataRole.map((e) => {
    return {
      value: e.role_id,
      label: e.role_description,
    };
  });

  const getValueRole = (value, options) => {
    const return_value = options.filter((val) => value === val.value);
    return return_value;
  };

  const handleRoleChange = (e) => {
    if (e === null) {
      e = undefined;
      setRole("");
    } else {
      setRole(e.value);
      setSelected({ role_id: e.value, role_description: e.label });
    }
  };

  const handleAddRole = () => {
    // Validation
    if (role === "") {
      return showDialog("Please Select Role");
    } else {
      const isExist = listRole.some(
        (item) => item.role_id === selected.role_id
      );

      if (isExist) {
        showDialog("Role already exists!");
      } else {
        setRole("");
        setSelected(null);
        setListRole((role) => [...role, selected]);
      }
    }
  };

  const handleSaveOffice = async () => {
    if (office === "") {
      return showDialog("Please Select Office");
    }
    if (listRole.length < 1) {
      return showDialog("Please add Role");
    }

    const params = {
      username: dataId.username,
      office_id: office,
      is_base: selectedValue,
      roles: listRole,
    };

    const updateparams = {
      useroffice_id: userOfficeID,
      username: dataId.username,
      user_id: dataUser.user_id,
      office_id: office,
      is_base: selectedValue,
      roles: listRole,
    };
    console.log(params, "params");
    console.log(userOfficeID, "userOfficeID");

    if (selectedValue === "Y") {
      const action = await showConfirmDialog(
        `Are you sure want to make this Office into base office?`
      );
      if (action.isConfirmed) {
        if (userOfficeID === "") {
          try {
            const response = await dispatch(addOfficeUser(params));
            if (response.payload.status === 200) {
              const action = await showSuccessDialog(
                response.payload.data.message
              );
              await callApi(id);
              await handleClose();
            } else if (
              response.payload.data.error === "10008" ||
              response.payload.data.error === "10009"
            ) {
              const action = await showErrorDialog(
                response.payload.data.message
              );
              await history.push("/logout");
            } else {
              showErrorDialog(response.payload.data.message);
            }
          } catch (error) {
            showErrorDialog(error.message);
          }
        } else {
          try {
            const response = await dispatch(editOfficeUser(updateparams));
            if (response.payload.status === 200) {
              const action = await showSuccessDialog(
                response.payload.data.message
              );
              await callApi(id);
              await handleClose();
            } else if (
              response.payload.data.error === "10008" ||
              response.payload.data.error === "10009"
            ) {
              const action = await showErrorDialog(
                response.payload.data.message
              );
              await history.push("/logout");
            } else {
              showErrorDialog(response.payload.data.message);
            }
          } catch (error) {
            showErrorDialog(error.message);
          }
        }
      }
    } else {
      if (userOfficeID === "") {
        try {
          const response = await dispatch(addOfficeUser(params));
          if (response.payload.status === 200) {
            const action = await showSuccessDialog(
              response.payload.data.message
            );
            await callApi(id);
            await handleClose();
          } else if (
            response.payload.data.error === "10008" ||
            response.payload.data.error === "10009"
          ) {
            const action = await showErrorDialog(response.payload.data.message);
            await history.push("/logout");
          } else {
            showErrorDialog(response.payload.data.message);
          }
        } catch (error) {
          showErrorDialog(error.message);
        }
      } else {
        try {
          const response = await dispatch(editOfficeUser(updateparams));
          if (response.payload.status === 200) {
            const action = await showSuccessDialog(
              response.payload.data.message
            );
            await callApi(id);
            await handleClose();
          } else if (
            response.payload.data.error === "10008" ||
            response.payload.data.error === "10009"
          ) {
            const action = await showErrorDialog(response.payload.data.message);
            await history.push("/logout");
          } else {
            showErrorDialog(response.payload.data.message);
          }
        } catch (error) {
          showErrorDialog(error.message);
        }
      }
    }
  };

  const typePhone = dataParam2.map((e) => {
    return {
      value: e.param_code,
      label: e.param_value,
    };
  });

  const [fields, setFields] = useState([
    {
      cp_id: "",
      emp_id: "",
      phone_type: "",
      phone: "",
    },
  ]);

  function handlePhoneChange(i, event) {
    const values = [...fields];
    values[i].phone = event.target.value;
    setFields(values);
  }

  function handleAdd() {
    const values = [...fields];
    values.push({
      cp_id: "",
      emp_id: dataId.emp_id,
      phone_type: "",
      phone: "",
    });
    setFields(values);
    return true;
  }

  function handleRemove(i) {
    const values = [...fields];
    values.splice(i, 1);
    setFields(values);
  }
  
  const handleTypeChange = (i, event) => {
    const values = [...fields];
    values[i].phone_type = event.value;
    setFields(values);
    return true;
  };

  const getValueType = (value, options) => {
    const return_value = options.filter((val) => value === val.value);
    return return_value;
  };

  const countryOptions = dataCountry.map((e) => {
    return {
      value: e.country_id,
      label: e.country_name,
    };
  });

  const [selectedValue, setSelectedValue] = useState("Y");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: {
        ...formValues[name],
        value,
      },
    });
    return true;
  };

  const handleChangeBaseOffice = (event) => {
    setSelectedValue(event.target.value);
  };

  const index = countryOptions.findIndex((obj) => obj.value === country_id);
  return loading ? (
    <LayoutSplashScreen />
  ) : (
    dataId && list && (
      <>
        <Card>
          <CardHeader>
            <CardHeaderTitle className="card-title text-white ">
              User Profile : {dataId.first_name} {dataId.last_name}
            </CardHeaderTitle>
            <CardHeaderToolbar>
              <Button
                className="primary"
                onClick={() =>
                  history.push("/administration/management-user/user")
                }
              >
                Back To List
              </Button>
            </CardHeaderToolbar>
          </CardHeader>

          <CardBody>
            <ButtonToolbar>
              {list.map((list) => (
                <Button
                  active={active === list}
                  onClick={() => setActive(list)}
                  variant="outline-primary"
                  className="m-2 "
                >
                  {list}
                </Button>
              ))}
            </ButtonToolbar>
            <ThemeProvider theme={formLabelsTheme}>
              <>
                {active === "Basic Information" && (
                  <CardBody>
                    <Row>
                      <Col xs={12} sm={3} md={6} lg={6}>
                        <RedditTextField
                          required
                          label="Employee ID"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          name="emp_id"
                          value={formValues.emp_id.value}
                          onChange={handleChange}
                          error={formValues.emp_id.error}
                          helperText={
                            formValues.emp_id.error ? (
                              <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                                {iconError} {"This field is required"}
                              </FormHelperText>
                            ) : (
                              ""
                            )
                          }
                        />
                        <RedditTextField
                          label="Job Role"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          onChange={(e) => {
                            setDesignation(e.target.value);
                          }}
                          value={designation}
                        />
                        <RedditTextField
                          required
                          label="Address Line 1"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          multiline
                          rows="4"
                          name="address1"
                          value={formValues.address1.value}
                          onChange={handleChange}
                          error={formValues.address1.error}
                          helperText={
                            formValues.address1.error ? (
                              <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                                {iconError} {"This field is required"}
                              </FormHelperText>
                            ) : (
                              ""
                            )
                          }
                        />
                        <RedditTextField
                          label="City"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          onChange={(e) => {
                            setCity(e.target.value);
                          }}
                          value={city}
                        />
                        <RedditTextField
                          label="Province"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          onChange={(e) => {
                            setProvince(e.target.value);
                          }}
                          value={province}
                        />
                      </Col>
                      <Col xs={12} sm={3} md={6} lg={6}>
                        {" "}
                        <RedditTextField
                          required
                          label="First Name"
                          inputProps={{ maxLength: 128 }}
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          name="first_name"
                          value={formValues.first_name.value}
                          onChange={handleChange}
                          error={formValues.first_name.error}
                          helperText={
                            formValues.first_name.error ? (
                              <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                                {iconError} {"This field is required"}
                              </FormHelperText>
                            ) : (
                              ""
                            )
                          }
                        />
                        <RedditTextField
                          label="Last Name"
                          inputProps={{ maxLength: 128 }}
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          onChange={(e) => {
                            setLast_name(e.target.value);
                          }}
                          value={last_name}
                        />
                        <RedditTextField
                          label="Address Line 2"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          onChange={(e) => {
                            setAddress2(e.target.value);
                          }}
                          value={address2}
                          multiline
                          rows="4"
                        />
                        <RedditTextField
                          label="Zipcode"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          onChange={(e) => {
                            setZipcode(e.target.value);
                          }}
                          value={zipcode}
                        />
                        <Autocomplete
                          disablePortal
                          options={countryOptions}
                          getOptionLabel={(option) => option.label.toString()}
                          disableClearable={true}
                          onChange={(e, value) => setCountry_id(value.value)}
                          value={countryOptions[index]}
                          renderInput={(params) => (
                            <RedditTextField
                              required
                              className={classes.margin}
                              {...params}
                              label="Country"
                              id="reddit-input"
                              size="small"
                              fullWidth
                              placeholder="Select Country"
                            />
                          )}
                        />
                      </Col>
                    </Row>
                    <p className="font-weight-bold  m-3">Contact Details :</p>
                    <Row>
                      <Col xs={12} sm={3} md={6} lg={6}>
                        {fields.map((field, idx) => {
                          return (
                            <div key={`${field}-${idx}`}>
                              <Row>
                                <Col md={4}>
                                  <Select
                                    // isClearable={true}
                                    options={typePhone}
                                    value={getValueType(
                                      field.phone_type,
                                      typePhone
                                    )}
                                    placeholder="Select Type"
                                    onChange={(e) => handleTypeChange(idx, e)}
                                    className="mt-4 ml-3"
                                  />
                                </Col>
                                <Col md={6}>
                                  <RedditTextField
                                    inputProps={{
                                      maxLength: 20,
                                      onInput: (e) => {
                                        if (e.target.value.length > 20) {
                                          e.target.value = e.target.value.slice(
                                            0,
                                            20
                                          );
                                        }
                                      },
                                    }}
                                    label="Phone Number"
                                    className={classes.margin}
                                    variant="filled"
                                    id="reddit-input"
                                    type="number"
                                    size="small"
                                    fullWidth
                                    value={field.phone || ""}
                                    onChange={(e) => handlePhoneChange(idx, e)}
                                  />
                                </Col>
                                {fields.length !== 1 && (
                                  <Col>
                                    <div
                                      className="btn btn-icon btn-primary btn-hover-primary btn-sm mt-4 "
                                      onClick={() => handleRemove(idx)}
                                    >
                                      <span className="svg-icon svg-icon-md svg-icon-light">
                                        <SVG
                                          src={toAbsoluteUrl(
                                            "/media/svg/icons/New/X.svg"
                                          )}
                                        />
                                      </span>
                                    </div>
                                  </Col>
                                )}
                                <Col sm={1}>
                                  {fields.length - 1 === idx && (
                                    <Button
                                      variant="outline-primary"
                                      onClick={(e) => handleAdd()}
                                      className="mt-4 ml-3"
                                    >
                                      Add
                                    </Button>
                                  )}
                                </Col>
                              </Row>
                            </div>
                          );
                        })}
                      </Col>

                      <Col xs={12} sm={3} md={6} lg={6}>
                        <RedditTextField
                          label="Email"
                          inputProps={{ maxLength: 128 }}
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          onChange={(e) => {
                            setCp_email(e.target.value);
                          }}
                          value={cp_email}
                        />
                      </Col>
                    </Row>
                    {checkPermision(permissionBasicInfo, "UPDATE") && (
                      <Row className="mt-6 justify-content-end">
                        <Button variant="primary" onClick={handleSaveBasicInfo}>
                          Save
                        </Button>
                      </Row>
                    )}
                  </CardBody>
                )}
                {active === "Account Setting" && (
                  <CardBody>
                    <Row>
                      <Col xs={12} sm={3} md={4} lg={4}>
                        <RedditTextField
                          required
                          label="User Login ID"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          name="username"
                          disabled={dataId.username === null ? false : true}
                          value={
                            dataId.username === null
                              ? formUser.username.value
                              : dataId.username
                          }
                          onChange={handleChangeUser}
                          error={formUser.username.error}
                          helperText={
                            formUser.username.error ? (
                              <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                                {icon} {"This field is required"}
                              </FormHelperText>
                            ) : (
                              ""
                            )
                          }
                        />
                      </Col>
                    </Row>
                    {checkPermision(permissionAccount, "UPDATE") && (
                      <Row>
                        <Button
                          variant="outline-primary"
                          onClick={handleLock}
                          className="m-5"
                        >
                          Unlock User
                        </Button>
                        <Button
                          variant="outline-primary"
                          onClick={handleReset}
                          className="m-5"
                        >
                          Reset Password
                        </Button>
                        <Button
                          variant="outline-primary"
                          onClick={handleRelaseuser}
                          className="m-5"
                        >
                          Reset User
                        </Button>
                      </Row>
                    )}
                    <Row className="my-4 ">
                      <Col md={2}>Data Status</Col>
                      {dataUser && <Col>: {dataUser.status_enable}</Col>}
                    </Row>
                    <Row className="my-4">
                      <Col md={2}>Activity Status</Col>
                      {dataUser && <Col>: {dataUser.status_online}</Col>}
                    </Row>
                    <Row className="my-4">
                      <Col md={2}>Locked Status</Col>
                      {dataUser && <Col>: {dataUser.status_locked}</Col>}
                    </Row>

                    {checkPermision(permissionAccount, "UPDATE") && (
                      <>
                        {dataId.username === null && (
                          <Row className="mt-6 justify-content-end">
                            <Button variant="primary" onClick={handleSaveUser}>
                              Save
                            </Button>
                          </Row>
                        )}
                      </>
                    )}
                  </CardBody>
                )}
                {active === "Office Mapping" && (
                  <CardBody>
                    {checkPermision(permissionOfficeMapping, "CREATE") && (
                      <>
                        {dataId.username !== null && (
                          <Button
                            className="btn btn-primary my-btn-primary-dark  mb-5"
                            onClick={handleShow}
                          >
                            Map Office
                          </Button>
                        )}
                      </>
                    )}

                    <BootstrapTable
                      wrapperClasses="table-responsive"
                      classes="table table-head-custom table-vertical-center overflow-hidden rounded"
                      bootstrap4
                      keyField="No"
                      data={dataUser === null ? [] : tableDataUserOffice}
                      columns={columns}
                      // sort={{ dataField: sortField, order: sortOrder }}
                      hover
                      striped
                      headerClasses="header-class"
                    />
                  </CardBody>
                )}
              </>
            </ThemeProvider>
          </CardBody>
        </Card>

        {/* Modal Create */}
        <Modal
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={show}
          onHide={handleClose}
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter text-white">
              {userOfficeID === "" ? "New" : "Edit"} Office Mapping
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className="title-card-modal ">Office Details</p>
            <hr></hr>
            <Row>
              <Col xs={12} sm={3} md={6} lg={6}>
                <Select
                  // isClearable={true}
                  options={officeOptions}
                  value={getValueRole(office, officeOptions)}
                  placeholder="Select Office *"
                  onChange={handleOfficeChange}
                />
              </Col>
              <Col xs={12} sm={3} md={6} lg={6}>
                <div className="border-m">
                  <p className="m-0 p-0">Base Office</p>
                  <RadioGroup
                    row
                    value={selectedValue}
                    onChange={handleChangeBaseOffice}
                  >
                    <FormControlLabel
                      value="Y"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="N"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                </div>
              </Col>
            </Row>
            <p className="title-card-modal mt-4 ">Role Mapping</p>
            <hr></hr>
            <Row>
              <Col xs={12} sm={3} md={6} lg={6}>
                <Select
                  isClearable={true}
                  options={roleOptions}
                  value={getValueRole(role, roleOptions)}
                  placeholder="Select Role *"
                  onChange={handleRoleChange}
                />
              </Col>
              <Col xs={12} sm={3} md={1} lg={1}>
                <Button variant="outline-primary" onClick={handleAddRole}>
                  Add
                </Button>
              </Col>
            </Row>

            <BootstrapTable
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden rounded mt-10"
              bootstrap4
              keyField="no"
              data={listRole}
              columns={columnsOffice}
              // sort={{ dataField: sortField, order: sortOrder }}
              hover
              striped
              headerClasses="header-class"
            />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            <Button variant="primary" onClick={handleSaveOffice}>
              Save
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    )
  );
};
